import React from "react";
//import logo from "./logo.svg";
import "./App.css";
//import Header from "./Component/Header/Header";
//import Footer from "./Component/Footer/Footer";
import Home from "./pages/Home/Home";
import ScrollManager from "./Component/ScrollManager";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
//import Home from "./pages/Home";
import Privacy from './pages/Privacy'
import Terms from "./pages/Terms";
import Betasignup from "./Component/BetaSignup/Betasignup";
import ThankYou from "./pages/ThankYou";
import BetaCongratulation from "./pages/BetaCongratulation";
import BetaThankyou from "./pages/BetaThankyou";
import { UserFormDataProvider } from "./context/FormDataContext";
import RentDirect2 from "./Component/RentDirect2/RentDirect2";
import Rentshield2 from "./Component/RentShield2/Rentshield2";
import RentId2 from "./Component/Rentid2/RentId2";
import RentAcademy2 from "./Component/RentAcademy2/RentAcademy2";
import RentSuccess2 from "./Component/RentSuccess2/RentSuccess2";
import Guest from "./Component/Guest/Guest";
//import AnimationCards from "./Component/SupportTeam/Animationcards";
import HostSignup from "./Component/HostSignup/HostSignup";
import GuestSignup from "./Component/Guest/GuestSignup";
import ConfirmDetails from "./Component/Guest/ConfirmDetails";
import GuestForgotEmail from "./Component/Guest/GuestForgotEmail";
import GuestForgotNumber from "./Component/Guest/GuestForgotNumber";
import GuestEmailVerification from "./Component/Guest/GuestEmailVerification";
import GuestNumberVerification from "./Component/Guest/GuestNumberVerification";
import GuestResetPassword from "./Component/Guest/GuestResetPassword";
import PrimaryCommericialSub from "./Component/RentShield2/Primary-commericial-sub/PrimaryCommericialSub";
import RentAI from "./pages/RentAI/RentAI";
import GeneralQuestion from "./pages/Contactuspage/GeneralQuestion";
import Contactuspage from "./pages/Contactuspage/Contactuspage";
import PressMedia from "./pages/Contactuspage/PressMedia";
import Affilates from "./pages/Contactuspage/Affilates";
import ApplyAcademy from "./Component/RentAcademy2/ApplyAcademy/ApplyAcademy";
import InvestorRelation from "./pages/Contactuspage/InvestorRelation";
import ApplyAffilates from "./Component/RentAcademy2/ApplyAffilates/ApplyAffilates";
import AccessibilityStatement from "./pages/AccessibilityStatement"
import RoadsideTerms from "./pages/RoadsideTerms";
import { ToastContainer } from "react-toastify";
import NotFound from './pages/NotFoundPage/NotFound';
import { Helmet } from "react-helmet";
import AnoucementPage from './pages/AnoucementPage/AnoucementPage';
import CancellationRefund from "./pages/CancellationRefund/CancellationRefund";
import BlogsPage from './pages/Blogs/BlogsPage'
import MaximumBooking from "./pages/Blogs/MaximumBooking/MaximumBooking";
import IdentityVerification from "./pages/Blogs/IdentityVerification/IdentityVerification";
import FleetOperators from "./pages/Blogs/FleetOperators/FleetOperators";
import MarketPlaceBlog from "./pages/Blogs/MarketPlaceBlog/MarketPlaceBlog";
import RentShieldEmpowers from "./pages/Blogs/RentShieldEmpowers/RentShieldEmpowers";
import RentVehiclestoRideshare from "./pages/Blogs/RentVehiclestoRideshare/RentVehiclestoRideshare";
import AirbnbHosts from "./pages/Blogs/AirbnbHosts/AirbnbHosts";
import CarRental from "./pages/Solutions/CarRental/CarRental";
import CarSharing from "./pages/Solutions/CarSharing/CarSharing";
import RideSharing from "./pages/Solutions/RideSharing/RideSharing";
import Delivery from "./pages/Solutions/Delivery/Delivery";
import AutoDealerships from "./pages/Solutions/AutoDealerships/AutoDealerships";
import ServiceRepair from "./pages/Solutions/ServiceRepair/ServiceRepair";
import VacationRental from "./pages/Solutions/VacationRental/VacationRental";
import HotelResort from "./pages/Solutions/HotelResort/HotelResort";
import PropertyMgmt from "./pages/Solutions/PropertyMgmt/PropertyMgmt";
import Corporate from "./pages/Solutions/Corporate/Corporate";
import Government from "./pages/Solutions/Government/Government";
import Education from "./pages/Solutions/Education/Education";
import Fleets from "./pages/Fleet/Fleets/Fleets";
import FleetFive from "./pages/Fleet/FleetFive/FleetFive";
import FleetTwentyFive from "./pages/Fleet/FleetTwentyFive/FleetTwentyFive";
import FleetFifty from "./pages/Fleet/FleetFifty/FleetFifty";
import FleetHundred from "./pages/Fleet/FleetHundred/FleetHundred";
import Technology from "./pages/Technology/Technology";
import Industry from "./pages/Industry/Industry";
import Support from "./pages/Support/Support";
import Features from "./pages/Features/Features";
import Learn from "./pages/Learn/Learn";
import ContactSales from "./pages/ContactSales/ContactSales";
import Platform from "./pages/Platform/Platform";
import Enterprise from "./pages/Enterprise/Enterprise";
import EnterpriseGetStarted from "./pages/Enterprise/EnterpriseGetStarted";
import EnterpriseLogin from "./pages/Enterprise/EnterpriseLogin";
import Marketplace from "./pages/Marketplace/Marketplace";
// import Pricing from "./pages/Pricing/Pricing"; // hidden for now (owner 2026-10-01): /pricing redirects to /#plans
import CostBreak from "./pages/CostBreak/CostBreak";
import About from "./pages/About/About";
import Launch from "./pages/Contactuspage/Launch";
 import Icrs from "./pages/IcrsLandingPage/Icrs";
import ExploreDemo from "./pages/IcrsLandingPage/ExploreDemo";
import IcrsEvent from "./pages/IcrsEvent/IcrsEvent";
import TuroAlternative from "./pages/TuroAlternative/TuroAlternative";
import TransitionPlan from "./pages/TransitionPlan/TransitionPlan";
import VipOnboarding from "./pages/VipOnboarding/VipOnboarding";
import PreOnboarding from "./pages/PreOnboarding/PreOnboarding";
import InshurLp from "./pages/InshurLp/InshurLp";
import InshurLandingPage from "./pages/InshurLandingPage/InshurLandingPage";
import TntGroup from "./pages/TntGroup/TntGroup";
import BlogsPage1 from "./pages/Blogs/BlogsPage1";
import BlogTemplate from "./pages/Blogs/BlogTemplate/BlogTemplate";
import BrandGuidelines from "./pages/BrandGuidelines/BrandGuidelines";

function ExternalRedirect({ to }) {
  React.useEffect(() => {
    window.location.replace(to);
  }, [to]);
  return null;
}

/* Routes that keep the dark design system. Every other page was reverted to its original light design
   (owner, 2026-10-02) and gets body.rd-classic, which switches off rd-site.css's page-content rules there;
   the header and footer stay dark on every page. */
const DARK_ROUTES = new Set(["/", "/rentdirect", "/rentshield", "/rent-id", "/rentacademy", "/rentsuccess", "/rentai", "/inshur", "/inshurlandingpage"]);

function App() {
  const { pathname } = useLocation();
  React.useLayoutEffect(() => {
    const path = pathname.replace(/\/+$/, "").toLowerCase() || "/";
    document.body.classList.toggle("rd-classic", !DARK_ROUTES.has(path));
  }, [pathname]);

  return (
    <div className="App">
      {process.env.REACT_APP_STAGE === "STAGING" && (<Helmet>
        <meta name="robots" content="noindex, nofollow" />
        <meta name="googlebot" content="noindex, nofollow" />
      </Helmet>)}
      {/* Scroll to top (or to #anchor) on every in-app navigation. */}
      <ScrollManager />
      <Routes>
        <Route path="/accessibility-statement" element={<AccessibilityStatement />} />
        <Route path="/rentdirect" element={<RentDirect2 key={new Date().getDate()} />} />
        <Route path="/rentshield" element={<Rentshield2 key={new Date().getDate()} />} />
        <Route path="/rent-id" element={<RentId2 key={new Date().getDate()} />} />
        <Route path="/rentid" element={<Navigate to="/rent-id" replace />} />
        <Route path="/rentacademy" element={<RentAcademy2 key={new Date().getDate()} />} />
        <Route path="/rentsuccess" element={<RentSuccess2 key={new Date().getDate()} />} />
        <Route path="/guest" element={<Guest />} />
        <Route path="/host" element={<ExternalRedirect to="https://app.rentid.io/login" />} />

        <Route path="/guest-signup" element={<GuestSignup />} />
        
        <Route path="/confirm-details" element={<ConfirmDetails />} />
        <Route path="/guest-forgot-email" element={<GuestForgotEmail />} />
        <Route path="/guest-forgot-number" element={<GuestForgotNumber />} />
        <Route path="/guest-email" element={<GuestEmailVerification />} />
        <Route path="/guest-number" element={<GuestNumberVerification />} />
        <Route path="/guest-reset-password" element={<GuestResetPassword />} />
        <Route path="/primary-commericial" element={<PrimaryCommericialSub />} />
        <Route path="/rentai" element={<RentAI />} />
        <Route path="/general-question" element={<GeneralQuestion />} />
        <Route path="/contact-us" element={<Contactuspage />} />
        <Route path="/launch" element={<Launch />} />
        <Route path="/press-media" element={<PressMedia />} />
        <Route path="/affiliates" element={<Affilates />} />
        <Route path="/apply-academy" element={<ApplyAcademy />} />
        <Route path="/apply-affilates" element={<ApplyAffilates />} />
        <Route path="/investor-relation" element={<InvestorRelation />} />
        <Route path="/getaround" element={<AnoucementPage />} />
        <Route path="/blogs" element={<BlogsPage/>}/>
        <Route path="/blog/:slug" element={<BlogTemplate />} /> 
        <Route path="/blog-template" element={<BlogsPage1/>}/>
        <Route path="/maximum-booking" element={<MaximumBooking/>}/>
        <Route path="/identity-verification" element={<IdentityVerification/>}/>
        <Route path="/fleet-operators" element={<FleetOperators/>}/>
        <Route path="/market-place" element={<MarketPlaceBlog/>}/>
        <Route path="/rentshield-empowers" element={<RentShieldEmpowers/>}/>
        <Route path="/rent-vehicles-to-rideshare" element={<RentVehiclestoRideshare/>}/>
        <Route path="/airbnb-hosts" element={<AirbnbHosts/>}/>
        <Route path="/car-rental" element={<CarRental/>}/>
        <Route path="/car-sharing" element={<CarSharing/>}/>
        <Route path="/ride-sharing" element={<RideSharing/>}/>
        <Route path="/delivery" element={<Delivery/>}/>
        <Route path="/auto-dealerships" element={<AutoDealerships/>}/>
        <Route path="/service-repair" element={<ServiceRepair/>}/>
        <Route path="/vacation-rental" element={<VacationRental/>}/>
        <Route path="/hotel-resort" element={<HotelResort/>}/>
        <Route path="/property-management" element={<PropertyMgmt/>}/>
        <Route path="/corporate" element={<Corporate/>}/>
        <Route path="/government" element={<Government/>}/>
        <Route path="/education" element={<Education/>}/>
        <Route path="/fleets" element={<Fleets/>}/>
        <Route path="/fleet-5" element={<FleetFive/>}/>
        <Route path="/fleet-25" element={<FleetTwentyFive/>}/>
        <Route path="/fleet-50" element={<FleetFifty/>}/>
        <Route path="/fleet-100" element={<FleetHundred/>}/>
        <Route path="/technology" element={<Technology/>}/>
        <Route path="/industry" element={<Industry/>}/>
        <Route path="/support" element={<Support/>}/>
        <Route path="/learn" element={<Learn/>}/>
        <Route path="/features" element={<Features/>}/>
        <Route path="/contact-sales" element={<ContactSales/>}/>
        <Route path="/platform" element={<Platform/>}/>
        <Route path="/enterprise" element={<Enterprise/>}/>
        <Route path="/enterprise/get-started" element={<EnterpriseGetStarted/>}/>
        <Route path="/enterprise/login" element={<EnterpriseLogin/>}/>
        <Route path="/marketplace" element={<Marketplace/>}/>
        {/* Owner (2026-10-01): /pricing is hidden for now; pricing lives at the bottom of the home page. */}
        <Route path="/pricing" element={<Navigate to="/#plans" replace />}/>
        <Route path="/costbreak" element={<CostBreak/>}/>
        <Route path="/about-us" element={<About/>}/>
        <Route path="/brand-guidelines" element={<BrandGuidelines/>}/>
         <Route path="/icrs" element={<Icrs/>}/>  
        <Route path="/explore-demo" element={<ExploreDemo/>} />
        <Route path="/icrs-event" element={<IcrsEvent/>} />
        <Route path="/turo-alternative" element={<TuroAlternative/>} />
        <Route path="/transition-plan" element={<TransitionPlan/>} />
        <Route path="/tnt-group" element={<TntGroup/>} />
        <Route path="/get-started" element={<VipOnboarding/>} />
        <Route path="/vip-onboarding" element={<Navigate to="/get-started" replace />} />
        <Route path="/pre-onboarding" element={<PreOnboarding/>} />
        <Route path="/inshurlp" element={<InshurLp/>} />
        <Route path="/inshur" element={<InshurLandingPage/>} />
        {/* Old URL of the INSHUR landing page (renamed 2026-10-13); vercel.json also 308s it. */}
        <Route path="/inshurlandingpage" element={<Navigate to="/inshur" replace />} />
        <Route path="*" element={<NotFound />} />
        <Route path="/" element={<Home />} />
        <Route path="privacy" element={<Privacy />} />
        <Route path="terms" element={<Terms />} />
        <Route path="/cancellation-and-refund-policy" element={<CancellationRefund/>} />
        <Route path="/roadside-terms" element={<RoadsideTerms />} />
        <Route
          path="beta-signup"
          element={
            <UserFormDataProvider>
              <Betasignup />
            </UserFormDataProvider>
          }
        />
        <Route
          path="thankyou"
          element={
            <UserFormDataProvider>
              <ThankYou />
            </UserFormDataProvider>
          }
        />
        <Route
          path="host-signup"
          element={
            <UserFormDataProvider>
              <HostSignup />
            </UserFormDataProvider>
          }
        />
        <Route path="congratulation" element={<BetaCongratulation />} />
        <Route path="betathankyou" element={<UserFormDataProvider>
          <BetaThankyou />
        </UserFormDataProvider>} />
      </Routes>
      <ToastContainer pauseOnFocusLoss={false} role="alert" />
    </div>
  );
}

export default App;
